
import actionTypes from '../actions/reduxActions/actionTypes';

const organizationTenants = (state = [], { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.ORGANIZATION_TENANTS_SET_ALL:

        return payload;

    default:
        return state;
    }
};

export default organizationTenants;
